// // import React, { useState } from 'react';
// // import {
// //   Box,
// //   Button,
// //   Typography,
// //   IconButton,
// //   Stack,
// //   Paper
// // } from '@mui/material';
// // import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// // import VisibilityIcon from '@mui/icons-material/Visibility';
// // import DownloadIcon from '@mui/icons-material/Download';
// // import DeleteIcon from '@mui/icons-material/Delete';

// // const ResumeUpload = () => {
// //   const [resumeFile, setResumeFile] = useState(null);
// //   const [previewUrl, setPreviewUrl] = useState(null);

// //   const handleFileChange = (e) => {
// //     const file = e.target.files[0];
// //     if (file && (file.type === "application/pdf" || file.type.includes("word"))) {
// //       setResumeFile(file);
// //       setPreviewUrl(URL.createObjectURL(file));
// //     } else {
// //       alert("Please upload a PDF or Word document.");
// //     }
// //   };

// //   const handleRemove = () => {
// //     setResumeFile(null);
// //     setPreviewUrl(null);
// //   };

// //   const handleDownload = () => {
// //     if (resumeFile && previewUrl) {
// //       const a = document.createElement("a");
// //       a.href = previewUrl;
// //       a.download = resumeFile.name;
// //       a.click();
// //     }
// //   };

// //   return (
// //     <Box sx={{ p: 3, maxWidth: 500, mx: 'auto' }}>
// //       <Typography variant="h6" gutterBottom>
// //         Upload Resume
// //       </Typography>

// //       {!resumeFile ? (
// //         <Button
// //           component="label"
// //           variant="contained"
// //           startIcon={<CloudUploadIcon />}
// //         >
// //           Upload File
// //           <input
// //             type="file"
// //             hidden
// //             accept=".pdf,.doc,.docx"
// //             onChange={handleFileChange}
// //           />
// //         </Button>
// //       ) : (
// //         <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
// //           <Typography variant="subtitle1" fontWeight="bold">
// //             {resumeFile.name}
// //           </Typography>
// //           <Typography variant="body2" color="text.secondary">
// //             {resumeFile.type}
// //           </Typography>

// //           <Stack direction="row" spacing={1} mt={2}>
// //             <IconButton color="primary" onClick={() => window.open(previewUrl, '_blank')}>
// //               <VisibilityIcon />
// //             </IconButton>
// //             <IconButton color="success" onClick={handleDownload}>
// //               <DownloadIcon />
// //             </IconButton>
// //             <IconButton color="error" onClick={handleRemove}>
// //               <DeleteIcon />
// //             </IconButton>
// //           </Stack>
// //         </Paper>
// //       )}
// //     </Box>
// //   );
// // };

// // export default ResumeUpload;


// import React, { useState } from 'react';
// import {
//     Box,
//     Button,
//     Typography,
//     IconButton,
//     Stack,
//     Paper,
//     Dialog,
//     DialogContent,
//     DialogTitle,
//     CardContent,
//     Divider,
//     Card
// } from '@mui/material';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DownloadIcon from '@mui/icons-material/Download';
// import DeleteIcon from '@mui/icons-material/Delete';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

// const ResumeUpload = () => {
//     const [resumeFile, setResumeFile] = useState(null);
//     const [previewUrl, setPreviewUrl] = useState(null);
//     const [openModal, setOpenModal] = useState(false);

//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file && file.type === "application/pdf") {
//             setResumeFile(file);
//             setPreviewUrl(URL.createObjectURL(file));
//         } else {
//             alert("Please upload a PDF document only.");
//         }
//     };

//     const handleRemove = () => {
//         setResumeFile(null);
//         setPreviewUrl(null);
//         setOpenModal(false);
//     };

//     const handleDownload = () => {
//         if (resumeFile && previewUrl) {
//             const a = document.createElement("a");
//             a.href = previewUrl;
//             a.download = resumeFile.name;
//             a.click();
//         }
//     };

//     return (
//         <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5,alignItems:"center",height:"70vh" }}>
//             <Card sx={{ width: '90%', maxWidth: 800, boxShadow: 3 }}>
//                 <CardContent>
//                     <Typography variant="h6" gutterBottom>Upload Your Resume (PDF)</Typography>
//                     <Divider />
//                     <Box
//                         sx={{
//                             p: 3,
//                             // minHeight: '80vh',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             justifyContent: 'center',
//                             alignItems: 'center',
//                             bgcolor: '#f5f5f5',
//                         }}
//                     >
//                         {/* <Typography variant="h5" gutterBottom fontWeight="bold">
//                             Upload Your Resume (PDF)
//                         </Typography> */}

//                         {!resumeFile ? (
//                             <Button
//                                 component="label"
//                                 variant="outlined"
//                                 sx={{
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                     py: 4,
//                                     px: 6,
//                                     borderRadius: 2,
//                                     borderStyle: 'dashed',
//                                     borderColor: 'gray',
//                                     bgcolor: '#fff',
//                                     cursor: 'pointer',
//                                     textTransform: 'none',
//                                     '&:hover': {
//                                         borderColor: 'primary.main',
//                                         bgcolor: '#f0f0f0',
//                                     },
//                                 }}
//                             >
//                                 <CloudUploadIcon sx={{ fontSize: 80, color: 'var(--main-color)' }} />
//                                 <Typography variant="h6" mt={1}>
//                                     Upload PDF
//                                 </Typography>
//                                 <input
//                                     type="file"
//                                     hidden
//                                     accept=".pdf"
//                                     onChange={handleFileChange}
//                                 />
//                             </Button>
//                         ) : (
//                             <Paper elevation={3} sx={{ p: 2, mt: 3, textAlign: 'center', width: 300 }}>
//                                 <PictureAsPdfIcon sx={{ fontSize: 50, color: 'var(--main-color)' }} />
//                                 <Typography variant="subtitle1" fontWeight="bold" mt={1}>
//                                     {resumeFile.name}
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary">
//                                     {resumeFile.type}
//                                 </Typography>

//                                 <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
//                                     <IconButton color="primary" onClick={() => setOpenModal(true)}>
//                                         <VisibilityIcon />
//                                     </IconButton>
//                                     <IconButton color="success" onClick={handleDownload}>
//                                         <DownloadIcon />
//                                     </IconButton>
//                                     <IconButton color="error" onClick={handleRemove}>
//                                         <DeleteIcon />
//                                     </IconButton>
//                                 </Stack>
//                             </Paper>
//                         )}

//                         {/* PDF Preview Modal */}
//                         <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="md" fullWidth>
//                             <DialogTitle>PDF Preview</DialogTitle>
//                             <DialogContent>
//                                 {previewUrl && (
//                                     <iframe
//                                         src={previewUrl}
//                                         title="PDF Preview"
//                                         width="100%"
//                                         height="500px"
//                                         style={{ border: 'none' }}
//                                     />
//                                 )}
//                             </DialogContent>
//                         </Dialog>
//                     </Box>
//                 </CardContent>
//             </Card>
//         </Box>
//     );
// };

// export default ResumeUpload;

import React, { useState } from 'react';
import {
    Box,
    Button,
    Typography,
    IconButton,
    Stack,
    Paper,
    Dialog,
    DialogContent,
    DialogTitle,
    CardContent,
    Divider,
    Card
} from '@mui/material';
import { Formik, Form } from 'formik';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { toast } from 'react-toastify';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';
import actions from '../../../../ReduxStore/actions';
import { useDispatch } from 'react-redux';

const ResumeUpload = ({ handleAddFormGoBackButton }) => {
    const [previewUrl, setPreviewUrl] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const handleFileChange = (e, setFieldValue) => {
        const file = e.target.files[0];
        if (file && file.type === "application/pdf") {
            setFieldValue("resume", file);
            setPreviewUrl(URL.createObjectURL(file));
        } else {
            alert("Please upload a PDF document only.");
        }
    };

    const handleDownload = (resumeFile) => {
        if (resumeFile && previewUrl) {
            const a = document.createElement("a");
            a.href = previewUrl;
            a.download = resumeFile.name;
            a.click();
        }
    };
    const [loading, setLoading] = useState(false);


    const alumni_user_id = sessionStorage.getItem("alumni_user_id")

    const dispatch = useDispatch()
    const handleSubmit = async (values, { resetForm }) => {
        console.log("Form Values of contact form:", values);
        setLoading(true);

        const formData = new FormData();

        // Make sure resume exists and is a File
        if (values.resume instanceof File) {
            formData.append("uploadresume", values.resume);
        } else {
            toast.error("Please upload a valid resume.");
            setLoading(false);
            return;
        }

        const data1 = {
            data: formData,
            method: "post",
            apiName: `addpostresume/${alumni_user_id}`,
            isFormData: true,
        };

        const responseData = await dispatch(actions.EVENTPOST(data1));

        if (responseData?.payload?.message === "Resume uploaded successfully.") {
            setLoading(false);
            resetForm();
            // setUploadedFile([]); // Assuming this manages UI state
            handleAddFormGoBackButton();
            setTimeout(() => {
                toast.success(`Resume uploaded successfully.`);
            }, 1500);
        } else {
            setLoading(false);
            toast.error(responseData?.payload?.message || "Upload failed.");
        }
    };




    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5, alignItems: "center", height: "70vh" }}>
            {loading && <FullPageLoader />}

            <Card sx={{ width: '90%', maxWidth: 800, boxShadow: 3 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>Upload Your Resume (PDF)</Typography>
                    <Divider />
                    <Box
                        sx={{
                            p: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            bgcolor: '#f5f5f5',
                        }}
                    >
                        <Formik
                            initialValues={{ resume: null }}
                            onSubmit={handleSubmit}
                        >
                            {({ setFieldValue, values, resetForm }) => (
                                <Form style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    {!values.resume ? (
                                        <Button
                                            component="label"
                                            variant="outlined"
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                py: 4,
                                                px: 6,
                                                borderRadius: 2,
                                                borderStyle: 'dashed',
                                                borderColor: 'gray',
                                                bgcolor: '#fff',
                                                cursor: 'pointer',
                                                textTransform: 'none',
                                                '&:hover': {
                                                    borderColor: 'primary.main',
                                                    bgcolor: '#f0f0f0',
                                                },
                                            }}
                                        >
                                            <CloudUploadIcon sx={{ fontSize: 80, color: 'var(--main-color)' }} />
                                            <Typography variant="h6" mt={1}>
                                                Upload PDF
                                            </Typography>
                                            <input
                                                type="file"
                                                hidden
                                                accept=".pdf"
                                                onChange={(e) => handleFileChange(e, setFieldValue)}
                                            />
                                        </Button>
                                    ) : (
                                        <Paper elevation={3} sx={{ p: 2, mt: 3, textAlign: 'center', width: 300 }}>
                                            <PictureAsPdfIcon sx={{ fontSize: 50, color: 'var(--main-color)' }} />
                                            <Typography variant="subtitle1" fontWeight="bold" mt={1}>
                                                {values.resume.name}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {values.resume.type}
                                            </Typography>

                                            <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
                                                <IconButton color="primary" onClick={() => setOpenModal(true)}>
                                                    <VisibilityIcon />
                                                </IconButton>
                                                <IconButton color="success" onClick={() => handleDownload(values.resume)}>
                                                    <DownloadIcon />
                                                </IconButton>
                                                <IconButton color="error" onClick={() => {
                                                    resetForm();
                                                    setPreviewUrl(null);
                                                    setOpenModal(false);
                                                }}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Stack>
                                            {/* <Button type='submit'>Submit</Button> */}
                                        </Paper>
                                    )}

                                    {values.resume && (
                                        <Button
                                            // type="submit"
                                            variant="contained"
                                            color="var(--main-color)"
                                            type="submit"
                                            sx={{ mt: 3, px: 4, background: "var(--main-color)", color: "white" }}
                                        >
                                            Save
                                        </Button>
                                    )}
                                </Form>
                            )}
                        </Formik>

                        {/* PDF Preview Modal */}
                        <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="md" fullWidth>
                            <DialogTitle>PDF Preview</DialogTitle>
                            <DialogContent>
                                {previewUrl && (
                                    <iframe
                                        src={previewUrl}
                                        title="PDF Preview"
                                        width="100%"
                                        height="500px"
                                        style={{ border: 'none' }}
                                    />
                                )}
                            </DialogContent>
                        </Dialog>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ResumeUpload;
